// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, of } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { User } from '../../models/b2b/user';
import { DashboardHelper } from '../../models/b2b/dashboard';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class SoledadDashboardService {
    constructor(private api: ApiService) {}

    getDashboardInfo(clienteCodigo: string, selectedAddress: number, almacenCodigo: string): Observable<any> {
        if (!clienteCodigo) {
            return of(false);
        }

        // Params
        const params = {};
        params['DIRENVIO'] = selectedAddress;
        params['PANTALLA'] = 'HOME';
        params['CLIENTE'] = clienteCodigo;
        params['ALMACEN'] = almacenCodigo;

        // params['TIPO_VEHICULO'] = (searchType === SearchType.all) ? vehicleType.get(SearchType.all) : vehicleType.get(searchType);

        // params['ACCESO'] =

        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_PantallaLeer', params).pipe(
            map((data) => {
                if (data && data.value) {
                    return data.value.map((row) => DashboardHelper.transformFromApi(row));
                } else {
                    return of(false);
                }
            })
        );
    }

    getModelo347(user: User): Observable<any> {
        if (!user) {
            return of(false);
        }

        // Params
        const params = {};
        params['CLIENTE'] = user.clienteCodigo;

        // console.log('HTML_Modelo347', params);

        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_Modelo347', params).pipe(
            validateApiResponse('Error obteniendo modelo 347' + '. Params: ' + JSON.stringify(params)),
            map((data: any) => {
                return data[0].IM_URL;
            })
        );
    }
}
